import { combineReducers } from 'redux';
import {
  authorityAcc, authorityCust,
  loggedAcc, loggedCust,
  // curUrl
}  from './authority';

const rootReducer = combineReducers({
  authorityAcc, authorityCust,
  loggedAcc, loggedCust,
  // curUrl,
});

export default rootReducer;